// Shared trigger styling for every filter-bar picker (`RelationshipFilter`,
// `FacetMultiSelectFilter`, and `PresetDateRangeFilter`'s own `className`
// prop) — one icon-led trigger shape so the whole row reads as a single
// control family. Targets antd's internal `.ant-select-selector` node
// directly (the same `[&_...]:` Tailwind-arbitrary-variant technique already
// used elsewhere in this codebase, e.g. the empty-table scrollbar-gutter
// fix) — `!` modifiers because AntD's own generated selector class carries
// more specificity than an unmarked Tailwind utility.
//
// Geometry follows `UI_UX_GUIDELINES.md` §3.2/§3.3 rather than this page's
// own earlier pill look: 36px control height, 6px control radius
// (`rounded-md`), and the guidelines' own `0 1px 1px rgba(0,0,0,.05)`
// trigger shadow. `text-[13px]` (down from antd's 14px default) so a longer
// label like "Project Manager (3)" still fits its trigger without
// truncating, paired with the `w-[190px]` each picker's own `className`
// uses. The arrow/prefix/placeholder rules only normalise sizes and muted
// tones across the row — antd still renders its own default chevron, so
// every picker keeps the identical glyph.
export const FILTER_PILL_CLASS = [
  "[&_.ant-select-selector]:!h-10",
  "[&_.ant-select-selector]:!items-center",
  "[&_.ant-select-selector]:!rounded-lg",
  "[&_.ant-select-selector]:!border-[#E2E8F0]",
  "[&_.ant-select-selector]:!bg-white",
  "[&_.ant-select-selector]:!px-3",
  "[&_.ant-select-selector]:!text-[13px]",
  "[&_.ant-select-selector]:!shadow-[0_2px_6px_rgba(15,23,42,0.06)]",
  "hover:[&_.ant-select-selector]:!border-slate-300",
  "[&.ant-select-focused_.ant-select-selector]:!border-primary",
  "[&.ant-select-focused_.ant-select-selector]:!shadow-[0_0_0_3px_rgba(42,125,140,0.14)]",
  "[&_.ant-select-selection-placeholder]:!text-slate-700",
  "[&_.ant-select-selection-item]:!text-slate-800",
  "[&_.ant-select-prefix]:!text-slate-600",
  "[&_.ant-select-prefix_.anticon]:!text-[15px]",
  "[&_.ant-select-arrow]:!text-slate-600",
  "[&_.ant-select-arrow]:!text-[12px]"
].join(" ")
